import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import LogoMarquee from "@/components/sections/LogoMarquee";
import Features from "@/components/sections/Features";
import HowItWorks from "@/components/sections/HowItWorks";
import Showcase from "@/components/sections/Showcase";
import Testimonials from "@/components/sections/Testimonials";
import FeatureVideo from "@/components/sections/FeatureVideo";
import Download from "@/components/sections/Download";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative min-h-screen overflow-x-hidden bg-[#0A0A0A] text-zinc-100">
      <div className="noise-overlay fixed inset-0 z-[1]" aria-hidden="true" />
      <Header />
      <main className="relative z-10">
        <Hero />
        <LogoMarquee />
        <Features />
        <HowItWorks />
        <Showcase />
        <Testimonials />
        <FeatureVideo />
        <Download />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
